import {
  ICatalogueExamenWebServiceClient,
  IFavorisWebServiceClient,
  LigneCatalogueExamenDto
} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {ArianeStore, NotificationService, WindowService, CorrespondantStore} from "@digicerba/common";
import {Component} from "@angular/core";
import {AsiDialogView} from "@asi-ngtools/lib";

@Component({
  selector: 'detail-examen-component',
  templateUrl: './detail-examen.component.html',
  host: {'class': 'page'}
})
export class DetailExamenPageComponent extends AsiDialogView {

  detail: LigneCatalogueExamenDto;
  printing: boolean = false;

  constructor(arianeStore: ArianeStore, private activatedRoute: ActivatedRoute, private favorisWebServiceClient: IFavorisWebServiceClient,
              private catalogueExamenWebService: ICatalogueExamenWebServiceClient, private windowService: WindowService,
              private correspondantStore: CorrespondantStore, private notificationService: NotificationService) {
    super();
  }

  ngOnInit() {
    let detail: LigneCatalogueExamenDto = this.activatedRoute.snapshot.data['detail'];
    if (detail) {
      this.detail = detail;
    }
  }

  isFr(): boolean {
    if (this.correspondantStore.hasTag('fr')) {
      if (!this.correspondantStore.hasTag('en')) {
        return true;
      }
    }
    return false;
  }

  ajoutFavori(ligne: LigneCatalogueExamenDto): void {
    this.favorisWebServiceClient.ajoutFavori(ligne.identifiantLcds).subscribe();
    ligne.favori = !ligne.favori;
  }

  suppressionFavori(ligne: LigneCatalogueExamenDto): void {
    this.favorisWebServiceClient.supressionFavori(ligne.identifiantLcds).subscribe();
    ligne.favori = !ligne.favori;
  }

  toggleFavori(ligne: LigneCatalogueExamenDto): void {
    if (ligne.favori) {
      this.suppressionFavori(ligne);
    } else {
      this.ajoutFavori(ligne);
    }
  }

  sendMail(id: number) {
    this.catalogueExamenWebService.mailDetailExamen(id).subscribe(() => {
      this.notificationService.showSuccessNotification("ACTION.mail_envoye");
    }, () => {
      this.notificationService.showErrorNotification("ACTION.mail_erreur");
    });
  }

  print() {
    if (this.hasDialog()) {
      let className = this.dialog.viewContainerRef.element.nativeElement.className;
      this.dialog.viewContainerRef.element.nativeElement.className += " print";
      this.windowService.openPrint();
      this.dialog.viewContainerRef.element.nativeElement.className = className;
    }

    // Si on n'est pas dans une modale alors on met l'attribut print sur
    // la div ayant la class page-container
    else {
      let pageContainer = document.getElementsByClassName("page-container");

      if (pageContainer.length > 0) {
        let className = pageContainer[0].className;
        pageContainer[0].className += " print";
        this.windowService.openPrint();
        pageContainer[0].className = className;
      }
    }
  }

  close() {
    if (this.hasDialog())
      this.dialog.close();
  }

  /**
   * Teste si on a un attribut dialog dans le composant
   * Si on n'en a pas c'est qu'on n'est pas dans la modale mais
   * dans la page de détail qui est atteignable via un email
   *
   * @returns {boolean} true si on a l'attribut dialog, false sinon
   * ============================================================== */
  hasDialog(): boolean {
    return this.dialog != null;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/detail-examen/detail-examen.component.ts